import { http } from './config'

export default {

  getAllUsersWeb: () => {
    return http.get('users_operacional')
  },

  getFilteredUserWeb: (params) => {
    return http.get('users_operacional', {params})
  },

  getUserWebById: (userWebID) => {
    return http.get('users/' + userWebID)
  },

  createUserWeb: (userWebParams) => {
    let genderOption = null

    if (userWebParams.gender.id == 1) {
      genderOption = 'M'
    } else if (userWebParams.gender.id == 2) {
      genderOption = 'F'
    }

    return http.post('users', {
      login: userWebParams.login,
      password: userWebParams.password,
      phone: userWebParams.phone,
      name: userWebParams.name,
      cpf: userWebParams.cpf,
      gender: genderOption,
      role_id: userWebParams.role_id.id,
      shift_id: userWebParams.shift_id.id
    })
},

  updateUserWeb: (userWebParams) => {
    let genderOption = null

    if (userWebParams.gender.id == 1) {
      genderOption = 'M'
    } else if (userWebParams.gender.id == 2) {
      genderOption = 'F'
    }

    return http.put('users/' + userWebParams.id, {
      login: userWebParams.login,
      password: userWebParams.password,
      phone: userWebParams.phone,
      name: userWebParams.name,
      cpf: userWebParams.cpf,
      gender: genderOption,
      role_id: userWebParams.role_id.id,
      shift_id: userWebParams.shift_id.id
    })
},

  deleteUserWeb: (userWebID) => {
    return http.delete('users/' + userWebID)
  }
}
